import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './ko';
import en from './en';
import ja from './ja';

const getSavedLanguage = (): string => {
  const savedLang = localStorage.getItem('language');
  if (savedLang && ['ko', 'en', 'ja'].includes(savedLang)) {
    return savedLang;
  }
  const browserLang = navigator.language.toLowerCase();
  if (browserLang.startsWith('ja')) return 'ja';
  if (browserLang.startsWith('ko')) return 'ko';
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
    ja: { translation: ja }
  },
  lng: getSavedLanguage(),
  fallbackLng: 'ko',
  interpolation: { escapeValue: false }
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
